import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Button, Form, Modal, Pagination } from "react-bootstrap";
import SuppliersTableRow from "./SuppliersTableRow";
import AxiosController from "../../../authentication/AxiosController";
import Loader from "../../../loader/Loader";
import { Helmet } from "react-helmet";
const get_shippingcosts = (
  slug,
  lang,
  token,
  shippingcostsHandler,
  handleLoader
) => {
  AxiosController.get(`api/${slug}/${lang}/get-shippingcost/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      shippingcostsHandler(res.data);
      handleLoader(false);
    })
    .catch((e) => {});
};
const get_warehouses = (
  slug,
  lang,
  token,
  handleWarehouses,
  courierId,
  page,
  handleLoader
) => {
  AxiosController.get(
    `api/${slug}/${lang}/get-shippingcost/`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      handleWarehouses(res.data);
      handleLoader(false);
    })
    .catch((e) => {});
};

const createWarehouse = (
  slug,
  lang,
  token,
  courierId,
  govId,
  cost,
  handling,
  extra_handling,
  handleLoader,
  setShow,
  handleSuppliers,
  taxRate,
  shippingCurrencyId,
  editingGovId
) => {
  handleLoader(true);
  const endpoint = `api/${slug}/${lang}/new-gov/`;
  console.log('editingGovId', editingGovId);
  console.log("taxRate", taxRate);
  console.log("shippingCurrencyId", shippingCurrencyId);
  
  AxiosController.post(
    endpoint,
    { 
      arabic_name: govId, 
      cost,
      tax_rate: taxRate,
      shipping_currency_id: shippingCurrencyId || null
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      get_warehouses(
        slug,
        lang,
        token,
        handleSuppliers,
        courierId,
        1,
        handleLoader
      );
      setShow(false);
    })
    .catch((e) => {
      // handleNewCourierNameErr(
      //   e.response.data.errors ? e.response.data.errors.name[0] : ""
      // );
      // handleCourierTypeErr(
      //   e.response.data.errors ? e.response.data.errors.type[0] : ""
      // );
      handleLoader(false);
    });
};

const GovPricing = () => {
  const { slug, lang, courierId } = useParams();
  const location = useLocation();
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [suppliers, handleSuppliers] = useState([]);
  const [loading, handleLoader] = useState(false);
  const [cost, setCost] = useState(0);
  const [handling, setHandling] = useState(0);
  const [extraHandling, setExtraHandling] = useState(0);
  const [show, setShow] = useState(false);
  const [shippingCosts, setShippingCosts] = useState([]);
  const [govId, setGovId] = useState("");
  const [page, handlePage] = useState(urlParams.get("page") || 1);
  const [taxRate, setTaxRate] = useState(0);
  const [currencies, setCurrencies] = useState([]);
  const [shippingCurrencyId, setShippingCurrencyId] = useState("");
  const [editingGovId, setEditingGovId] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const changeParam = (param, value) => {
    urlParams.set(param, value);
    Navigate(`?${urlParams.toString()}`);
  };
  useEffect(() => {
    handleLoader(true);
    const nextPage = parseInt(urlParams.get("page"), 10) || 1;
    handlePage(nextPage);
    get_shippingcosts(slug, lang, token, setShippingCosts, handleLoader);

    get_warehouses(
      slug,
      lang,
      token,
      handleSuppliers,
      courierId,
      nextPage,
      handleLoader
    );

    // Fetch currencies for the dropdown
    AxiosController.get(`api/ar/auth/user-currencies`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        setCurrencies(res.data);
      })
      .catch((e) => {});
  }, [slug, lang, location.search]);

  return (
    <div
      className="position-relative tables-container"
      style={{ minHeight: "100px", width: "100%" }}
    ><Helmet>
    <title>{_("panel.shippingCost")}</title> 
</Helmet>
      <Button
        variant="primary"
        onClick={() => {
          setCost(0)
          setGovId('')
          setTaxRate(0)
          setShippingCurrencyId('')
          setEditingGovId(null)
          handleShow(true)
        }}
        className='mt-4  '
        style={{ background: "#59C6C9", color: "white", border: "none" }}
      >
        {_("panel.add")}    
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">
            {_("panel.add")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
          {label_input(_("home.province"), govId, setGovId)} 
          {label_input(_("panel.cost"), cost, setCost)} 
          {label_input(_("panel.taxRate") || "نسبة الضريبة %", taxRate, setTaxRate)}
          <div className="mb-3">
            <label htmlFor="shippingCountry" className="form-label">
              {_("panel.shippingCountry") || "دولة الشحن"}
            </label>
            <select
              className="form-select"
              id="shippingCountry"
              value={shippingCurrencyId}
              onChange={(e) => setShippingCurrencyId(e.target.value)}
            >
              <option value="">{_("panel.selectCountry") || "اختر الدولة"}</option>
              {currencies.map((currency) => (
                <option value={currency.id} key={currency.id}>
                  {currency.country}
                </option>
              ))}
            </select>
          </div>
          {/* {newCourierNameErr ? (
            <Alert variant="danger">{newCourierNameErr}</Alert>
          ) : (
            ""
          )} */}
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button
            variant="primary"
            onClick={() => {

              createWarehouse(
                slug,
                lang,
                token,
                courierId,
                govId,
                cost,
                handling,
                extraHandling,
                handleLoader,
                setShow,
                handleSuppliers,
                taxRate,
                shippingCurrencyId,
                editingGovId
              );
            }}
          >
            {_("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Loader active={loading} />
      <div
        className="tables-container d-flex flex-column px-2"
        style={{ position: "relative", flexGrow: 3 }}
      >
        <div
          className={`header d-flex ${
            lang === "en" ? "flex-row" : "flex-row"
          } gap-3 align-items-center justify-content-between`}
        >
          <h3 className="fs-1" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.shippingCost")}{" "}
            <span style={{ color: "rgb(243, 168, 55)" }}>
              {suppliers.data ? suppliers.data[0].name : ""}
            </span>
          </h3>
        </div>
        <div className="footer d-flex flex-column flex-grow-1">
          {suppliers.length ? (
            <SuppliersTableRow
              payments_list={suppliers}
              handleLoader={handleLoader}
              setShow={setShow}
              setCost={setCost}
              setGovId={setGovId}
              setHandling={setHandling}
              setExtraHandling={setExtraHandling}
              setTaxRate={setTaxRate}
              setShippingCurrencyId={setShippingCurrencyId}
              setEditingGovId={setEditingGovId}
              currencies={currencies}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
const label_input = (label, newWarehouseName, handleNewWarehouseName) => {
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={newWarehouseName}
        onInput={(e) => handleNewWarehouseName(e.target.value)}
      />
    </div>
  );
};
export default GovPricing;
